
  export default {
    props: { width: { type: Number, default: 0 } }
  };
